import * as React from "react";
const SvgItalic = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 0V3H6.21L2.79 11H0V14H8V11H5.79L9.21 3H12V0H4Z", fill: "currentColor" }));
export default SvgItalic;
